import {
  accountBalance,
  accountBalanceForChildren,
  allBalance,
  allBalanceForChildren,
  gsCasinoBalance,
  gsCasinoBalanceForChildren,
  virtualBalance,
  virtualBalanceForChildren,
} from "../../js/api/profile.js";
import { getagents } from "../../js/api/getAgents.js";
import { getAccountBalanceTemplate } from "../templates/accountBalance.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let role = "";
let accountStartDate;
let accountEndDate;
let today = new Date();
let dd = String(today.getDate()).padStart(2, "0");
let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
let yyyy = today.getFullYear();

const getIndex = (type) => {
  switch (type.toString().toLowerCase()) {
    case "sport":
    case "baste":
      return 1;
    case "casino":
      return 2;
    case "casino/slots":
      return 3;
    case "aviator":
      return 10;
    default:
      return 5;
  }
};

function sortTypes(x, y) {
  if (x === y) return 0;
  const xIndex = getIndex(x);
  const yIndex = getIndex(y);
  return xIndex < yIndex ? -1 : 1;
}

today = yyyy + "-" + mm + "-" + dd;
let startDate = today;
let endDate = today;
const currencies = {
  1: "EUR",
  2: "LEK",
  3: "USD",
  4: "CHF",
  5: "GBP",
  6: "MKD",
};
const nonSportTypes = [
  "casino",
  "livecasino",
  "casino/slots",
  "virtual",
  "aviator",
];

let AccountBalance = {
  firstLoaded: false,
  render: async () => {
    role = localStorage.getItem("role");

    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));
      console.log(userCoins);
      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}">${_t("Monedha")}: ${Utils.currencyCode(coin.currency)}</option>`;
      });
    }

    let agents = await getagents(startDate, endDate, userCoins[0]);
    let agentsView = "";

    if (agents && agents.children_users.length !== 0) {
      const allIds = agents.children_users.map((a) => a.id);
      const uniqueIds = [...new Set(allIds)];
      uniqueIds.forEach((agentId) => {
        const agent = agents.children_users.find((a) => a.id === agentId);
        agentsView =
          agentsView + `<option value="${agent.id}">${agent.username}</option>`;
      });
    }

    // const account_balance = await accountBalance(startDate, endDate);

    // if (account_balance) {
    //   if (account_balance.length > 0) {
    //     account_balance.forEach((accBalance) => {
    //       accountBalanceView =
    //         accountBalanceView + getAccountBalanceTemplate(accBalance, role);
    //     });
    //   } else {
    //     accountBalanceView =
    //       accountBalanceView + getAccountBalanceTemplate(account_balance, role);
    //   }
    // }

    let view = /*html*/ `
      <div id="accountBalancePage">
            <div class="changePasswordHeader">
                 <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                 <span>${_t("Financa")}</span>
                 <select class="header-select" id="casinoAccountSelect">
                  <option value="" selected>${_t("ALL")}</option>
                  <option value="1">${_t("Sport")}</option>
                  <option value="2">${_t("Casino")}</option>
                  <option value="3">${_t("Virtual Games")}</option>
                 </select>
           </div>

           <div class="newMyBetsFilter">
            <input type="text" readonly  class="form-control" id="myCalendar1">
            <button type="button" class="btn-filter">${_t("Filtro")}</button>
           </div>

           <div class="my-bets-tabs" id="predefinedRanges">
           </div>

           <div class="my-bets-select-filters ${role === "User" ? "hidden" : ""}">
            <select name="accountCoinSelect" id="accountBalanceUserCoinSelect" class="${role == "User" ? "hidden" : ""}" placeholder="${_t("Monedha")}">
                ${userCoinsView}
            </select>
            <select name="accountAgentSelect" id="accountAgentSelect" class="${role == "User" ? "hidden" : ""}">
              <option value="">${_t("Zgjidh perdorues")}</option>
              ${agentsView}
            </select>
           </div>

           <div class="accountBalanceWrapper ${role != "User" ? "agentColumn" : ""}">
                <div class="accountBalanceContent">
                    <div class="accountBalanceContentHeader m-t-6 superMenagerHeader">
                        ${role != "User" ? ` <span>${_t("Info")}</span>` : "<span>*</span>"}
                        <span>${_t("Xhiro")}</span>
                        <span>${_t("Fitimi")}</span>
                        <span>${_t("Jackpot")}</span>
                        ${role != "User" ? "<span>%</span>" : ""}
                        ${role != "User" ? ` <span>${_t("Diferenca")}</span>` : ""}
                        ${role == "User" ? ` <span>${_t("Diferenca")}</span>` : ""}
                    </div>
                    
                    <div class="accountBalanceRows" id="accountBalanceTbl">
                      
                    </div>
                    ${
                      role != "User"
                        ? `<div class="accountBalanceContentHeader m-t-6" id="accountBalanceContentFooter">
                          <p style="text-align: center;color: white;font-size: 14px; padding: 10px;">${_t("Loading... Please wait!")}</p>
                        </div>`
                        : ""
                    }
                </div>
            </div>
          </div>
       `;
    return view;
  },
  after_render: async () => {
    $("body #predefinedRanges .my-bets-tabs__item").unbind("click");

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let months = [
      _t("Janar"),
      _t("Shkurt"),
      _t("Mars"),
      _t("Prill"),
      _t("Maj"),
      _t("Qershor"),
      _t("Korrik"),
      _t("Gusht"),
      _t("Shtator"),
      _t("Tetor"),
      _t("Nentor"),
      _t("Dhjetor"),
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {};
    ranges[_t("Sot")] = [moment(), moment()];
    ranges[_t("Dje")] = [
      moment().subtract(1, "days"),
      moment().subtract(1, "days"),
    ];
    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];
    today = yyyy + "-" + mm + "-" + dd;
    let startDate = today;
    let endDate = today;
    accountStartDate = startDate;
    accountEndDate = endDate;
    $("#myCalendar1").daterangepicker(
      {
        // ranges: ranges,
        alwaysShowCalendars: false,
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
        opens: "center",
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false,
        opens: "center",
        locale: {
          direction: "ltr",
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: "Apliko",
          cancelLabel: "Anulo",
          fromLabel: "Da",
          toLabel: "A",
          customRangeLabel: "Personalizzata",
          daysOfWeek: ["DI", "HA", "MA", "ME", "EN", "PR", "SH"],
          monthNames: months,
          firstDay: 1,
        },
      },
      async function (start, end, label) {
        $("#predefinedRanges .my-bets-tabs__item.active").removeClass("active");
        $("#contentLoader").append(
          '<div class="loaderWrapper">\n' +
            '            <div class="loader"></div>\n' +
            "        </div>",
        );
        let startDate = start.format("YYYY-MM-DD");
        let endDate = end.format("YYYY-MM-DD");
        accountStartDate = startDate;
        accountEndDate = endDate;

        renderBalance();

        $("body #accountBalanceTbl *").remove();
        $("body .loaderWrapper").remove();
      },
    );

    Object.keys(ranges).forEach((key) => {
      $("#predefinedRanges").append(
        `<div class="my-bets-tabs__item ${key === "Sot" ? "active" : ""}" data-value="${key}">${key}</div>`,
      );
    });

    $("body #predefinedRanges .my-bets-tabs__item").on(
      "click",
      async function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        // if ($(this).hasClass('active')) {
        //     return;
        // }
        const key = $(this).attr("data-value");
        if (ranges[key] !== undefined) {
          const range = ranges[key];
          if (range && range.length === 2) {
            $("#myCalendar1").data("daterangepicker").setStartDate(range[0]);
            $("#myCalendar1").data("daterangepicker").setEndDate(range[1]);
            console.log(range[0].format(), "123123");
            accountStartDate = range[0].format().split("T")[0];
            accountEndDate = range[1].format().split("T")[0];
            renderBalance();
            $("body #accountBalanceTbl *").remove();
          }
        }

        $("#predefinedRanges .my-bets-tabs__item.active").removeClass("active");
        $(this).addClass("active");
      },
    );

    $("body").on("change", "#accountAgentSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      renderBalance();

      $("body #accountBalanceTbl *").remove();
    });

    $("body").on("change", "#accountBalanceUserCoinSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });

    $("body").on("change", "#casinoAccountSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });

    // $("body").on("click", "#casinoAccountSelect .my-bets-tabs__item", async function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   e.stopImmediatePropagation();
    //   if ($(this).hasClass('active')) {
    //     return;
    //   }
    //   $('#casinoAccountSelect .my-bets-tabs__item.active').removeClass('active');
    //   $(this).addClass('active');
    //   renderBalance();
    //   $("body #accountBalanceTbl *").remove();
    // });

    $(document).ready(function () {
      renderBalance();
    });
  },
  hideFooterCasino: true,
};

async function renderBalance() {
  if (AccountBalance.firstLoaded === true) {
    window.stop();
  } else {
    AccountBalance.firstLoaded = true;
  }
  const id = $("#casinoAccountSelect").val();
  const userId = $("#accountAgentSelect").val();
  let totalBets = 0;
  let totalWinnings = 0;
  let totalReturn = 0;
  let totalPercentage = 0;
  let totalNet = 0;
  let totalJackpot = 0;
  let accountBalances;
  let typeLabel = "";
  let currency = $("#accountBalanceUserCoinSelect").val();
  if (id && id == 2) {
    if (userId) {
      accountBalances = await gsCasinoBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency,
      );
    } else {
      accountBalances = await gsCasinoBalance(
        accountStartDate,
        accountEndDate,
        currency,
      );
    }
  } else if (id && id == 1) {
    if (userId) {
      accountBalances = await accountBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency,
      );
    } else {
      accountBalances = await accountBalance(
        accountStartDate,
        accountEndDate,
        currency,
      );
    }
  } else if (id && id == 3) {
    if (userId) {
      accountBalances = await virtualBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency,
      );
    } else {
      accountBalances = await virtualBalance(
        accountStartDate,
        accountEndDate,
        currency,
      );
    }
  } else if (!id) {
    if (userId) {
      accountBalances = await allBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency,
      );
    } else {
      accountBalances = await allBalance(
        accountStartDate,
        accountEndDate,
        currency,
      );
    }
  }
  let accountBalanceView = "";

  if (accountBalances && id) {
    if (accountBalances.length > 0) {
      accountBalances.forEach((accBalance) => {
        totalBets += parseFloat(accBalance.stake ? accBalance.stake : 0);
        totalWinnings += parseFloat(accBalance.win ? accBalance.win : 0);
        totalPercentage += parseFloat(
          accBalance.percentage ? accBalance.percentage : 0,
        );
        totalReturn += parseFloat(
          accBalance.difference ? accBalance.difference : 0,
        );
        totalNet += parseFloat(
          accBalance.difference ? accBalance.difference : 0,
        );
        // accountBalanceView =
        // accountBalanceView + getAccountBalanceTemplate(accBalance, role);
      });
    } else {
      if (accountBalances.stake) {
        totalBets += parseFloat(
          accountBalances.stake ? accountBalances.stake : 0,
        );
        totalWinnings += parseFloat(
          accountBalances.win ? accountBalances.win : 0,
        );
        totalPercentage += parseFloat(
          accountBalances.percentage ? accountBalances.percentage : 0,
        );
        totalReturn += parseFloat(
          accountBalances.difference ? accountBalances.difference : 0,
        );
        totalNet += parseFloat(
          accountBalances.difference ? accountBalances.difference : 0,
        );
        // accountBalanceView =
        // accountBalanceView + getAccountBalanceTemplate(accountBalances, role);
      }
    }

    const uniqueTypes = [
      ...new Set(accountBalances.map((item) => item.type)),
    ].sort(sortTypes);
    console.log("Unique types 1: ", uniqueTypes);
    for (let index = 0; index < uniqueTypes.length; index++) {
      let currentTotalBets = 0;
      let currentTotalWinnings = 0;
      let currentTotalPercentage = 0;
      let currentTotalReturn = 0;
      let currentTotalNet = 0;
      let currentTotalJackpot = 0;
      const type = uniqueTypes[index];
      const balances = accountBalances.filter((a) => a.type == type);

      if (balances && balances.length)
        typeLabel = balances[0].type.toLowerCase();
      accountBalanceView += `
                    <div class="groupWrapper">
                        <div class="accountBalanceContentHeader m-t-6"><span>${_t(type).toUpperCase()}</span>
                    </div>
                    <div class="accountBalanceContent">
                        <div class="accountBalanceContentHeader whiteColor ${role != "User" && typeLabel == "baste" ? "" : "fiveColumnsHolder"}">
                            <span style="width:19%;">${_t("Info")}</span>
                            <span style="width:16%;">${_t("Xhiro")}</span>
                            <span style="width:16%;">${_t("Fitimi")}</span>
                            ${typeLabel == "baste" ? `<span style="width: 16%">-</span>` : `<span style="width: 16%">${_t("Jackpot")}</span>`}
                            ${role != "User" ? (typeLabel == "baste" ? `<span>%</span>` : "") : ""}
                            <span style="width:16%;">${_t("Diferenca")}</span>
                        </div>
                    </div>
                `;
      if (balances) {
        balances.forEach((accBalance) => {
          typeLabel = accBalance.type.toLowerCase();
          totalBets += parseFloat(accBalance.stake ? accBalance.stake : 0);
          currentTotalBets += parseFloat(
            accBalance.stake ? accBalance.stake : 0,
          );
          totalWinnings += parseFloat(accBalance.win ? accBalance.win : 0);
          currentTotalWinnings += parseFloat(
            accBalance.win ? accBalance.win : 0,
          );
          totalPercentage += parseFloat(
            accBalance.percentage ? accBalance.percentage : 0,
          );
          currentTotalPercentage += parseFloat(
            accBalance.percentage ? accBalance.percentage : 0,
          );
          currentTotalJackpot += parseFloat(
            accBalance.jackpot ? accBalance.jackpot : 0,
          );
          totalJackpot += parseFloat(
            accBalance.jackpot ? accBalance.jackpot : 0,
          );
          totalReturn += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          currentTotalReturn += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          totalNet += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          currentTotalNet += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          accountBalanceView =
            accountBalanceView + getAccountBalanceTemplate(accBalance, role);
        });
      }

      let currency = $("#accountBalanceUserCoinSelect").val();
      currency = currency ? " " + currencies[currency] : "";

      accountBalanceView += `
                <div class="accountBalanceContentHeader whiteColor ${role != "User" && typeLabel == "baste" ? "" : "fiveColumnsHolder"}">
                <span>Total</span>
                <span>${Utils.formatNumber(currentTotalBets)}</span>
                <span>${Utils.formatNumber(currentTotalWinnings)}</span>
                <span>${nonSportTypes.indexOf(typeLabel.toLowerCase()) !== -1 ? `${Utils.formatNumber(currentTotalJackpot)}` : "-"}</span>
                ${role != "User" && typeLabel == "baste" ? `<span>${Utils.formatNumber(currentTotalPercentage)}</span>` : ""}
                ${role != "User" ? ` <span>${Utils.formatNumber(currentTotalReturn, currency)}</span>` : ""}
                ${role == "User" ? ` <span>${Utils.formatNumber(currentTotalNet)}</span>` : ""}</div></div>
            `;
    }
  }

  if (accountBalances && !id) {
    const uniqueTypes = [
      ...new Set(accountBalances.map((item) => item.type)),
    ].sort(sortTypes);

    console.log("Unique types 2: ", uniqueTypes);
    for (let index = 0; index < uniqueTypes.length; index++) {
      let currentTotalBets = 0;
      let currentTotalWinnings = 0;
      let currentTotalPercentage = 0;
      let currentTotalReturn = 0;
      let currentTotalNet = 0;
      let currentTotalJackpot = 0;
      const type = uniqueTypes[index];
      const balances = accountBalances.filter((a) => a.type == type);

      if (balances && balances.length)
        typeLabel = balances[0].type.toLowerCase();
      accountBalanceView += `
                    <div class="groupWrapper">
                        <div class="accountBalanceContentHeader m-t-6"><span>${_t(type).toUpperCase()}</span>
                    </div>
                    <div class="accountBalanceContent">
                        <div class="accountBalanceContentHeader whiteColor ${role != "User" ? "fiveColumnsHolder" : ""}
                        ${role == "User" ? (nonSportTypes.indexOf(typeLabel) !== -1 ? "fiveColumnsHolder" : "fourColumnsHolder") : ""}
                        ">
                            <span style="width:19%;">${_t("Info")}</span>
                            <span style="width:16%;">${_t("Xhiro")}</span>
                            <span style="width:16%;">${_t("Fitimi")}</span>
                            ${typeLabel == "baste" ? `` : `<span style="width:16%">${_t("Jackpot")}</span>`}
                            ${role != "User" ? (typeLabel == "baste" ? `<span>%</span>` : "") : ""}
                            <span style="width:16%;">${_t("Diferenca")}</span>
                        </div>
                    </div>
                `;
      if (balances) {
        balances.forEach((accBalance) => {
          typeLabel = accBalance.type.toLowerCase();
          totalBets += parseFloat(accBalance.stake ? accBalance.stake : 0);
          currentTotalBets += parseFloat(
            accBalance.stake ? accBalance.stake : 0,
          );
          totalWinnings += parseFloat(accBalance.win ? accBalance.win : 0);
          currentTotalWinnings += parseFloat(
            accBalance.win ? accBalance.win : 0,
          );
          totalPercentage += parseFloat(
            accBalance.percentage ? accBalance.percentage : 0,
          );
          currentTotalPercentage += parseFloat(
            accBalance.percentage ? accBalance.percentage : 0,
          );
          currentTotalJackpot += parseFloat(
            accBalance.jackpot ? accBalance.jackpot : 0,
          );
          totalJackpot += parseFloat(
            accBalance.jackpot ? accBalance.jackpot : 0,
          );
          totalReturn += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          currentTotalReturn += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          totalNet += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          currentTotalNet += parseFloat(
            accBalance.difference ? accBalance.difference : 0,
          );
          accountBalanceView =
            accountBalanceView + getAccountBalanceTemplate(accBalance, role);
        });
      }

      let currency = $("#accountBalanceUserCoinSelect").val();
      currency = currency ? " " + currencies[currency] : "";
      accountBalanceView += `
                <div class="accountBalanceContentHeader whiteColor fiveColumnsHolder
                ${role == "User" ? (nonSportTypes.indexOf(typeLabel) !== -1 ? "fiveColumnsHolder" : "fourColumnsHolder") : ""}
                ">
                <span>Total</span>
                <span>${Utils.formatNumber(currentTotalBets)}</span>
                <span>${Utils.formatNumber(currentTotalWinnings)}</span>
                ${nonSportTypes.indexOf(typeLabel) !== -1 ? `<span>${Utils.formatNumber(currentTotalJackpot)}</span>` : ""}
                ${role != "User" && typeLabel == "baste" ? `<span>${Utils.formatNumber(currentTotalPercentage)}</span>` : ""}
                ${role != "User" ? ` <span>${Utils.formatNumber(currentTotalReturn, currency)}</span>` : ""}
                ${role == "User" ? ` <span>${Utils.formatNumber(currentTotalNet)}</span>` : ""}</div></div>
            `;
    }
  }

  $("body #accountBalanceTbl").append(accountBalanceView);

  if (role != "user") {
    let currency = $("#accountBalanceUserCoinSelect").val();
    currency = currency ? " " + currencies[currency] : "";

    $("body #accountBalanceContentFooter").empty();
    $("body #accountBalanceContentFooter").append(`
  <span>TOTAL</span>
  <span>${Utils.formatNumber(totalBets.toFixed(2))}</span>
  <span>${Utils.formatNumber(totalWinnings.toFixed(2))}</span>
  <span>${Utils.formatNumber(totalJackpot.toFixed(2))}</span>
  ${role != "User" ? `<span>${Utils.formatNumber(totalPercentage.toFixed(2))}</span>` : ""}
  ${role != "User" ? ` <span>${Utils.formatNumber(totalReturn.toFixed(2), currency)}</span>` : ""}
  ${role == "User" ? ` <span>${Utils.formatNumber(totalNet.toFixed(2), currency)}</span>` : ""}`);
  }

  $("body #accountBalanceTbl")
    .children(".accountBalanceContentHeader.m-t-6")
    .each(function (i, item) {
      $(
        '<div class="accountBalanceContentHeader whiteColor ' +
          ($(item).children("span").html().toLowerCase() == "baste"
            ? ""
            : "fiveColumnsHolder") +
          '">' +
          `
    ${role != "User" ? " <span>Info</span>" : "<span>*</span>"}
    <span>Xhiro</span>
    <span>Fitimi</span>
    <span>Jackpot</span>
    ${role != "User" && $(item).children("span").text().toLowerCase() == "baste" ? "<span>%</span>" : ""}
    ${role != "User" ? " <span>Diferenca</span>" : ""}
    ${role == "User" ? " <span>Diferenca</span>" : ""}
` +
          "</div>",
      ).insertAfter($(item));
    });

  $("body").on("click", ".accountBalanceContentHeader", function (e) {
    $(e.currentTarget).parent().toggleClass("clicked");
  });
}

export default AccountBalance;
